import jsonp from '@module/http/axios/jsonp';

export default class Vast {
  events = {};
  filenames = [];
  impressions = {};
  onReady = null; // Callback method (useful for getting the impressions mostly)

  constructor(sources = []) {
    // Attempt to load sources
    sources.forEach((source) => this.loadSource(source));
  }

  async loadSource(source) {
    try {
      const response = await jsonp({
        url: source,
        timeout: 30000,
      });
      this.parseResponse(response);
    } catch (e) {
      return;
    }
  }

  // Call this method to track an event for a file, this is
  // mainly used for HTML5 wallpapers.
  track(type, filename) {
    // If we receive a URL, we only want the filename.
    if (filename.indexOf('/') !== -1) {
      filename = filename.substring(filename.lastIndexOf('/') + 1);
    }

    // If there is only 1 vast tracker defined we can ignore the filename
    // because it doesn't matter (it should, but saves time booking inventory
    // in openx by just copying this stuff every time)
    if (this.filenames.length === 1) {
      filename = this.filenames[0];
    }

    if (type === 'impression') {
      this.trackImpression(filename);
      return;
    }

    // Make sure we know what events belong to this file
    if (!this.events || !this.events[filename]) {
      return;
    }
    if (!this.events[filename][type]) {
      return;
    }

    // Get our vast url
    const src = this.events[filename][type];
    this.createImageTag(src);
  }

  trackImpression(filename) {
    // Make sure we know what impressions belong to this file
    if (!this.impressions || !this.impressions[filename]) {
      return;
    }

    // Get our vast url
    const src = this.impressions[filename];
    this.createImageTag(src);
  }

  createImageTag(src) {
    let img = new Image();
    img.onload = () => {
      img.onload = null;
      img = null;
    };
    img.src = src;
  }

  // Because the VAST object is a big hunk of garbage we'll validate it
  // and then parse it in a more simpler form here.
  parseResponse({ body: data } = {}) {
    // Validate VAST object
    if (!data || !data.Ads || data.Ads.length < 1) {
      return false;
    }
    if (!data.Ads[0].Creatives || data.Ads[0].Creatives.length < 1) {
      return false;
    }
    if (!data.Ads[0].Creatives[0].Linear) {
      return false;
    }
    if (!data.Ads[0].Creatives[0].Linear.MediaFiles) {
      return false;
    }
    if (data.Ads[0].Creatives[0].Linear.MediaFiles.length < 1) {
      return false;
    }
    if (!data.Ads[0].Creatives[0].Linear.TrackingEvents) {
      return false;
    }
    if (data.Ads[0].Creatives[0].Linear.TrackingEvents.length < 1) {
      return false;
    }

    // Find the filename that is used here
    let filename = data.Ads[0].Creatives[0].Linear.MediaFiles[0].Uri;
    filename = filename.substring(filename.lastIndexOf('/') + 1);

    // Capture required impressions for this advert
    if (data.Ads[0].Impression) {
      this.impressions[filename] = data.Ads[0].Impression;
    }

    // Prepare to store events
    this.events[filename] = {};
    this.filenames.push(filename);

    // Loop through events
    const events = data.Ads[0].Creatives[0].Linear.TrackingEvents;
    Object.keys(events).forEach((type) => {
      const value = events[type];
      if (!value || value.length < 1) {
        return;
      }

      this.events[filename][type] = value[0];
    });

    // Let's do our callback
    if (typeof this.onReady === 'function') {
      this.onReady(this);
    }
  }
}
